import { render, staticRenderFns } from "./foots.vue?vue&type=template&id=11373254&scoped=true"
import script from "./foots.vue?vue&type=script&lang=js"
export * from "./foots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11373254",
  null
  
)

export default component.exports